window.Products.Clothing.AthleticCropTop = function() {
};
window.Products.Clothing.AthleticCropTop.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.AthleticCropTop.id = 61;
window.Products.Clothing.AthleticCropTop.slug = 'athletic-crop-top';
window.Products.Clothing.AthleticCropTop.has_3d = true;
window.Products.Clothing.AthleticCropTop.dpi = 150;

window.Products.Clothing.AthleticCropTop.prototype.set3dProperties = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[0].material.needsUpdate = true; //Force update the material with the design
    modelViewer.object.children[0].material.color = new THREE.Color(0.748900, 0.748900, 0.748900);
    
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map.minFilter = THREE.LinearMipMapLinearFilter;
    modelViewer.object.children[1].material.needsUpdate = true; //Force update the material with the design
    
    //Fade color using a combination of color and emissive (we might implement a custom shader eventually)
    modelViewer.object.children[1].material.color = new THREE.Color(0.2,0.2,0.2);
    modelViewer.object.children[1].material.emissive = new THREE.Color(0.7,0.7,0.7);

    modelViewer.camera.position.z = 1;
    modelViewer.camera.position.x = 0.4;
    modelViewer.initalCameraPosition.z = -1;
};

window.Products.Clothing.AthleticCropTop.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.3;
    controls.maxDistance = 1.75;
};

window.Products.Clothing.AthleticCropTop.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
};